import { DevelopmentInfo } from './DevelopmentInfo';
import { removeAuthDataStorage } from 'redux/actions';
import { useActions, useShallowEqualSelector } from 'core/redux/hooks';

export const DevelopmentInfoContainer = () => {
  const activeApplication = useShallowEqualSelector(
    (state) => state.userApplications.applicationActive
  );
  const loan = useShallowEqualSelector((state) => state.userApplications.loanActive);

  const listActions = useActions({
    removeAuthDataStorage,
  });

  return <DevelopmentInfo activeApplication={activeApplication} loan={loan} {...listActions} />;
};
